import { Dialog } from 'primereact/dialog'

export const Modal = ({
  children,
  noDismissable,
  visible = false,
  closable = true,
  style = {},
  header,
  footer,
  contentStyle = {},
  draggable = false,
  className = '',
  onHide = () => {}
}) => {
  const onHideFunction = () => (closable ? onHide() : null)
  return (
    <Dialog
      className={className || undefined}
      contentStyle={{ ...contentStyle }}
      header={header}
      modal
      dismissableMask={!noDismissable}
      draggable={draggable}
      showHeader={!!header}
      visible={visible}
      onHide={onHideFunction}
      closable={closable}
      style={{ ...style }}
      footer={footer}
    >
      {children}
    </Dialog>
  )
}
